export var DEFAULT_CHAR_LIMIT = 260;